/*
// jQuery: initResortLocationControls
// Search Filter Controls is used to handle navigation of the Resort Location google map
*/

window.app = window.app || {};

jQuery(function initResortLocationControls($) {

	$('#js-resort-location').each(function(index, el) {

		var latitude        = Number($('.js-resort-latitude').val());
		var longitude       = Number($('.js-resort-longitude').val());
		var map             = '';
		var service         = '';
		var infowindow      = '';
		var resortLatLng    = '';
		var bounds          = '';
		var markers         = [];
		var optionText      = '';
		var isTransitioning = false;

		// **************************************************************************************************************
		// FUNCTION:    mapApiLoadCheck
		// PARAMETERS:  none
		// DESCRIPTION: This function handles checking for initial google map load completion, then initializing map dependent controls
		// **************************************************************************************************************
		var mapApiLoadCheck = function() {

		    if (isMapsApiLoaded) {

		        clearInterval(intervalCheck);
		        initializeMapView();
		        initializeControls();
		    }
		}

		// **************************************************************************************************************
		// FUNCTION:    initializeControls
		// PARAMETERS:  none
		// DESCRIPTION: This function handles setting up the event handlers for the attraction location control
		// **************************************************************************************************************
		var initializeControls = function() {

			// **************************************************************************************************************
			// Attraction Location Control
			// **************************************************************************************************************
			$('.js-attraction').change(function(event) {

				if (!isTransitioning) {

					// Turn on the isTransitioning boolean to prevent other events from triggering
					isTransitioning = true;

					var placeType = $(this).val();
					optionText    = $(".js-attraction option:selected").text();

					var request = {
						location: resortLatLng,
						radius: '50000',
						types: [placeType]
					};

					service.nearbySearch(request, loadMapMarkers);
				}
				else {

					event.preventDefault();
				}
			});
		};

		// **************************************************************************************************************
		// FUNCTION:    initializeMapView
		// PARAMETERS:  none
		// DESCRIPTION: This function handles instantiating the map view with the google asynchronous loader
		// **************************************************************************************************************
		var initializeMapView = function() {

			initializeGoogleMap();
		};

		// **************************************************************************************************************
		// FUNCTION:    initializeGoogleMap
		// PARAMETERS:  none
		// DESCRIPTION: This function handles instantiating the google map and loading in the appropriate initial resort marker
		// **************************************************************************************************************
		var initializeGoogleMap = function() {
			// Instantiate the mapOptions variables so the map can be created
			//resortLatLng = new google.maps.LatLng(latitude, longitude);
			resortLatLng = new google.maps.LatLng(parseFloat(latitude), parseFloat(longitude));
			
			var mapOptions = {
				zoom: 17,
				center: resortLatLng
			};

			// Activate the initial map
			map = new google.maps.Map(document.getElementById('map-canvas'),mapOptions);

			// Initialize the places service library for the google map
			service = new google.maps.places.PlacesService(map);

			// Initialize the infow window library for the google map
			infowindow = new google.maps.InfoWindow();

			var marker = new google.maps.Marker({
				position: resortLatLng,
				map: map
			});
		};

		// **************************************************************************************************************
		// FUNCTION:    loadMapMarkers
		// PARAMETERS:  results (the places library results for the specified type)
		//              status (the request status of the current places library request)
		// DESCRIPTION: This function handles creating the map markers and sets of bounds for the map to be viewed on, and loading them into the google map canvas
		// **************************************************************************************************************
		var loadMapMarkers = function(results, status) {

			// Clear the existsting markers and bounds
			clearMarkersAndBounds();

			if (status === google.maps.places.PlacesServiceStatus.OK) {

				if ($('.js-resort-explore-area-error').hasClass('open')) {

					$('.js-resort-explore-area-error').removeClass('open');
					$('.js-resort-explore-area-error').fadeTo(window.app.fadeDurationShort,0).slideUp(window.app.slideDurationShort);
				}

				// Re-initialize the bounds on the original center point marker belonging to the resort
				bounds = new google.maps.LatLngBounds();
				bounds.extend(resortLatLng);

				$.each(results, function(key, value) {

					var place = value;

					var marker = new google.maps.Marker({
						position: place.geometry.location,
						map: map,
						icon: '//s3.amazonaws.com/rciglobal-assets/rci-plbe/img/places_marker.png'
					});

					google.maps.event.addListener(marker, 'click', function() {
						infowindow.setContent(place.name);
						infowindow.open(map, this);
					});

					markers.push(marker);
					bounds.extend(place.geometry.location);
				});

				google.maps.event.trigger(map, 'resize');
				map.fitBounds(bounds);

			}
			else {

				map.setZoom(17);
				map.setCenter(resortLatLng);

				$('.js-resort-explore-area-error').addClass('open');
				$('.js-resort-explore-area-error span.js-explore-area-attraction').text(optionText);
				$('.js-resort-explore-area-error').slideDown(window.app.slideDurationShort).fadeTo(window.app.fadeDurationShort,1);
			}

			isTransitioning = false;
		};

		// **************************************************************************************************************
		// FUNCTION:    clearMarkersAndBounds
		// PARAMETERS:  none
		// DESCRIPTION: This function handles remove existing markers from the map and then deleting them from memory, as well as resetting the map bounds
		// **************************************************************************************************************
		var clearMarkersAndBounds = function() {

			$.each(markers, function(key, marker) {

				// Destroy the existing click event tied to this marker
				google.maps.event.clearListeners(marker, 'click');

				// Remove this marker from the map, and then delete it from memory
				marker.setMap(null);
				marker = null;
			});

			// Clear the markers array to reset memory
			markers = [];
			bounds  = '';
		};

		// Check every 250ms if the google map has finished loading
		// After it has loaded, we can initialize the remainder of the interface controls

	    intervalCheck = setInterval(mapApiLoadCheck, 250);
	});
});